import { CommonExtension } from '../../../core/index.js';
import { Selection, TextSelection, Plugin, PluginKey } from 'prosemirror-state';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import 'prosemirror-model';

/**
 * 是否为表格内的位置
 * @param $pos ResolvedPos
 * @returns boolean
 */ var isInTablePos = function($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // 有 tableRole 属性的就是表格的 schema
        if ($pos.node(d).type.spec.tableRole) return true;
    }
    return false;
};
/**
 * 获取在表格中的真正可插入的节点的位置
 * @param $pos ResolvedPos
 * @returns number
 */ var getInsertPosInTable = function($pos) {
    // 不是表格内的 pos 不处理
    if (!isInTablePos($pos)) return null;
    var selectionRight = Selection.near($pos, 1);
    var selectionLeft = Selection.near($pos, -1);
    // 左右可用选区都没有
    if (!selectionRight && !selectionLeft) return null;
    var insertPos = $pos.pos;
    // 只有一边有选区, 那么就用一边的选区的位置
    if (selectionRight && !selectionLeft) {
        insertPos = selectionRight.from;
    } else if (!selectionRight && selectionLeft) {
        insertPos = selectionLeft.from;
    } else {
        // 选取左右最近的能插入的位置, 右侧优先
        insertPos = $pos.pos - selectionLeft.from < selectionRight.from - $pos.pos ? selectionLeft.from : selectionRight.from;
    }
    return insertPos;
};

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var imgExts = [
    "bmp",
    "gif",
    "jpg",
    "png",
    "tiff",
    "jpeg",
    "svg"
];
// 根据文件名称后缀判断是否为图片文件
function isImageFile(file) {
    var filename = file && file.name || "";
    if (!filename) {
        return false;
    }
    var segments = filename.split(".");
    if (segments.length < 2) {
        // 无后缀
        return false;
    }
    var suffix = segments.pop() || "";
    return imgExts.includes(suffix.toLowerCase());
}
var hasFile = function(items) {
    return items.some(function(item) {
        return item.kind === "file";
    });
};
var hasHTML = function(items) {
    return items.some(function(item) {
        return item.type === "text/html";
    });
};
var handleFilesPaste = function(view, commands, items) {
    if (!commands || !(commands.image || commands.attachment) || items.length === 0) {
        return false;
    }
    var images = [];
    var attachments = [];
    items.forEach(function(item) {
        var file = item.getAsFile();
        if (!file || !commands) {
            return;
        }
        if (!_instanceof(file, File)) {
            file = new File([
                file
            ], "clip.png");
        }
        if (isImageFile(file)) {
            images.push(file);
        } else {
            attachments.push(file);
        }
    });
    if (images.length > 0 && commands.image) {
        commands.image.upload(images);
    }
    if (attachments.length > 0 && commands.attachment) {
        commands.attachment.upload(attachments);
    }
    return true;
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var DropFileExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(DropFileExtension, CommonExtension);
    var _super = _createSuper(DropFileExtension);
    function DropFileExtension() {
        _classCallCheck(this, DropFileExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleDropEvent = function(view, event) {
            var isDrop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var data = event.clipboardData || event.dataTransfer;
            if (!data) return true;
            var items = Array.from(data.items);
            if (hasFile(items) && !hasHTML(items)) {
                event.preventDefault();
                if (isDrop) {
                    var pos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    // 获取表格内部真正可以插入的位置
                    var insertPosInTable = getInsertPosInTable(view.state.doc.resolve(pos.pos));
                    var insertPos = insertPosInTable === null ? pos.pos : insertPosInTable;
                    view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, insertPos)));
                }
                var fileItems = items.filter(function(item) {
                    return item.kind === "file";
                });
                return handleFilesPaste(view, _this.allCommands, fileItems);
            }
            return false;
        };
        _this.plugin = function() {
            return new Plugin({
                key: new PluginKey(_this.name),
                props: {
                    handleDOMEvents: {
                        paste: _this.handleDropEvent
                    },
                    handleDrop: function(view, event, slice, moved) {
                        if (moved) {
                            // 编辑器内部拖拽，此处不做处理
                            return false;
                        }
                        return _this.handleDropEvent(view, event, true);
                    }
                }
            });
        };
        return _this;
    }
    var _proto = DropFileExtension.prototype;
    _proto.didMountManager = function didMountManager(param) {
        var commands = param.commands;
        this.allCommands = commands;
    };
    _createClass(DropFileExtension, [
        {
            key: "name",
            get: function get() {
                return "drop-file";
            }
        }
    ]);
    return DropFileExtension;
}(CommonExtension);

export { DropFileExtension };
//# sourceMappingURL=index.js.map
